import React, { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);

const key = (pid, lang) => `${pid}::${lang}`;

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("cart")) || []; } catch { return []; }
  });
  // Persist cart to localStorage whenever items change. localStorage is a stable global; not reactive.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { localStorage.setItem("cart", JSON.stringify(items)); }, [items]);

  const addItem = (product, qty = 1, card_language = "fr") => {
    setItems((prev) => {
      const k = key(product.id, card_language);
      const found = prev.find((i) => key(i.product_id, i.card_language) === k);
      if (found) return prev.map((i) => (key(i.product_id, i.card_language) === k ? { ...i, quantity: i.quantity + qty } : i));
      const img = (product.images && product.images[card_language]) || product.image_url;
      return [...prev, { product_id: product.id, card_language, name: product.name, price: product.price, image_url: img, quantity: qty }];
    });
  };
  const updateQty = (pid, cardLang, qty) =>
    setItems((prev) => prev.map((i) => (key(i.product_id, i.card_language) === key(pid, cardLang) ? { ...i, quantity: Math.max(1, qty) } : i)));
  const removeItem = (pid, cardLang) =>
    setItems((prev) => prev.filter((i) => key(i.product_id, i.card_language) !== key(pid, cardLang)));
  const clearCart = () => setItems([]);
  const totalQty = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, addItem, updateQty, removeItem, clearCart, totalQty }}>
      {children}
    </CartCtx.Provider>
  );
};

export const useCart = () => useContext(CartCtx);
